import { Component } from '@angular/core';
import { MenuComponent } from "../../../shared/components/menu/menu.component";
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-kit-payment-success',
  imports: [CommonModule, MenuComponent, FooterComponent, RouterModule],
  templateUrl: './kit-payment-success.component.html',
  styleUrl: './kit-payment-success.component.css'
})
export class KitPaymentSuccessComponent {
}
